import React from 'react';
import GeneralAutocompleteFilter, { ConcreteAutocompleteFilterProps } from "./GeneralAutocompleteFilter";

const MediumCategoriesFilter: React.FC<ConcreteAutocompleteFilterProps> = props => {
    return (
        <GeneralAutocompleteFilter
            multiple
            name={ props.name || 'mediumCategoryIds' }
            label={ props.label || 'Kategorie' }
            onFilterChange={ props.onFilterChange }
            options={ props.options }
            values={ props.values }
        />
    );
}
export default MediumCategoriesFilter;